import React from 'react';
import styled from 'styled-components';
import { Icon } from 'components';
import { IconNameType } from 'components/Icon';

type DetailRowStyleOptions = {
  iconPaddingTop?: number;
};

const DetailRow: React.FC<
  DetailRowStyleOptions & {
    icon: IconNameType;
  }
> = ({ icon, iconPaddingTop, children, ...props }) => (
  <RowContainer {...props}>
    <IconContainer $iconPaddingTop={iconPaddingTop}>
      <Icon type={icon} width={20} color="textSecondary" />
    </IconContainer>
    <BodyContainer id="detail-row-body-old">{children}</BodyContainer>
  </RowContainer>
);

const RowContainer = styled.div`
  display: flex;
  &:not(:last-child) {
    margin-bottom: 32px;
  }
`;

const IconContainer = styled.div<{ $iconPaddingTop?: number }>`
  display: flex;
  ${({ $iconPaddingTop }) =>
    $iconPaddingTop !== undefined && `padding-top: ${$iconPaddingTop}px;`}
`;

const BodyContainer = styled.div`
  margin-left: 32px;
  font-size: 14px;
`;

export default DetailRow;
